export const API_URLS = {
  fileUpload: "uploadfile/?FTNorm=false",
  executeCleaning: "cleaning_effectiveness",
  executeCleaningStatus: "cleaning_effectiveness/status",
  cips: "cips",
  token: "token",
  uploadCips: "cips",
  cleanedData: "cleanedData",
  plantDetails: "details",
  fouling: "fouling",
  header: "header",
  foulingType: "foulingtype",
  bulk: "bulk",
  analysisjob: "analysisjob",
  analysisStatus: "analysis/status",
  analysis: "analysis",
  type: "type",
  plants: "plants",
  waterQualityDefaults: "water-quality-defaults",
  user: "user",
  segments: "segments",
  cols: "cols",
  colmapping: "colmapping",
  refcondition: "refcondition",
  visualization: "visualization",
  advancesettings: "advancesettings",
  proceedToAnalysis: "proceed_to_analysis",
  details: "details",
  state: "state",
  basePath: process.env.REACT_APP_BASEPATH,
  acceptTC: "accept_tc",
  share: "share",
  users: "users",
  accessRequest: "access-request",
  accessRequests: "access-requests",
  admin: "admin",
  exportExcel:"export-excel",
  cleaninganalysis:"cleanings/analysis"
};
